<template>
  <div class="wrapper">
    <div class="result">
      <div class="list-head order-box">
        <div class="order-id">订单编号</div>
        <div class="order-list">订单商品</div>
        <div class="order-time">下单时间</div>
      </div>
      <div class="order-box list-box">
        <div class="order-id">{{order_id}}</div>
        <div class="order-list">
          <div v-for="(item,index) in items" :key="index" class="product-item">
            <img :src="item.image_url" :alt="item.name" class="product-img">
            <div
              class="apply-btn"
              @click="changeSelected(item,index)"
              :class="{'active':item.checked}"
            >{{item.checked?'已选择':'申请'}}</div>
          </div>
        </div>
        <div class="order-time">{{orderTime}}</div>
      </div>
    </div>
    <!-- <div class="a-box">
      <span class="a-label top10">退款商品：</span>
      <div class="a-main">
        <img
          src="https://img.alicdn.com/bao/uploaded/i3/764655260/O1CN01Q33ZPQ1oj7nuDWjUV_!!0-item_pic.jpg"
          alt
          class="a-img"
        >
        <div class="a-name">南孚助听器电池A675锌空气电池</div>
      </div>
    </div>-->
    <div class="a-box">
      <span class="a-label">服务类型：</span>
      <div class="a-main">
        <el-radio v-model="type" label="1" @change="radioChange">仅退款</el-radio>
        <el-radio v-model="type" label="2" :disabled="isDisabled">退货退款</el-radio>
      </div>
    </div>
    <div class="a-box">
      <span class="a-label top10">退款金额：</span>
      <div class="a-main">
        <input type="number" :readonly="type==1" v-model="refund" class="a-price-input">
      </div>
    </div>
    <div class="a-box">
      <span class="a-label top10">退款说明：</span>
      <div class="a-main">
        <textarea
          name
          id
          cols="50"
          rows="5"
          maxlength="200"
          placeholder="退款说明"
          class="textarea"
          v-model="reason"
        ></textarea>
      </div>
    </div>
    <div class="a-box">
      <span class="a-label top10">上传图片：</span>
      <div class="a-main">
        <el-upload
          :action="upLoadUrl"
          list-type="picture-card"
          :limit="5"
          :http-request="e=>handleUpload(e)"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt>
        </el-dialog>
      </div>
    </div>
    <div class="submit" @click="handleSubmit">提交</div>
  </div>
</template>

<script>
import { timeToDate } from "@/utils";
import {apiBaseUrl} from "@/config/env.js";
export default {
  name: "RefundApply",
  components: {},
  props: {},
  data() {
    return {
      order_id: "",
      orderTime: "",
      type: "1",
      dialogImageUrl: "",
      dialogVisible: false,
      isDisabled: false, //是否禁用退货
      items: [], //商品列表
      refund: 0, //退款价格
      refund_show: 0, //可输入最大退款金额
      reason: "", //退款原因
      images: [],
      upLoadUrl: apiBaseUrl + "api.html",
      dialogVisible: false,
      dialogImageUrl: ""
    };
  },
  watch: {},
  computed: {
    item_ids() {
      let selectItems = this.items.filter(item => {
        return item.checked;
      });
      let item_ids = [];
      if (this.type == 1) {
        selectItems.forEach(item => {
          item_ids.push({
            id: item.id,
            nums: item.nums
          });
        });
      } else {
        selectItems.forEach(item => {
          if (item.sendnums > item.reship_nums) {
            let nums = item.sendnums - item.reship_nums;
            item_ids.push({
              id: item.id,
              nums: nums
            });
          }
        });
      }
      return item_ids;
    }
  },
  methods: {
    //上传图片
    handleUpload(e) {
      var formdata = new FormData();
      formdata.append("upfile", e.file, e.file.name);
      this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
        if (res.status) {
          this.images = this.images.concat(res.data.image_id);
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    handleSubmit() {
      if (this.refund > this.refund_show) {
        return this.$msg("退款金额过大", "warning");
      }
      if (this.item_ids.length == 0) {
        return this.$msg("请选择要申请的商品", "warning");
      }
      let data = {
        order_id: this.order_id,
        type: this.type,
        items: this.item_ids,
        images: this.images,
        refund: this.refund,
        reason: this.reason
      };
      this.$api.addAfterSales(data).then(res => {
        if (res.status) {
          this.$msg("提交成功");
          this.$router.go(-1);
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    radioChange(val) {
      this.refund = this.refund_show;
    },
    changeSelected(item, index) {
      if (item.checked) {
        this.items[index].checked = false;
      } else {
        this.items[index].checked = true;
      }
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //获取订单商品信息
    getOrderInfo() {
      let data = {
        order_id: this.order_id
      };
      this.$api.afterSalesStatus(data).then(res => {
        if (res.status) {
          //如果不是未支付的，已取消的，已完成的状态，就都可以售后
          if (
            res.data.text_status != 1 &&
            res.data.text_status != 6 &&
            res.data.text_status != 7
          ) {
            //判断是已付款未发货，如果是，就禁用退货
            if (res.data.text_status == 2) {
              this.isDisabled = true;
            }

            //设置已选中的商品
            for (var i = 0; i < res.data.items.length; i++) {
              res.data.items[i].id = res.data.items[i].id.toString();
              res.data.items[i].checked = true;
            }

            this.items = res.data.items;
            this.refund = res.data.payed - res.data.refunded;
            this.refund_show = res.data.payed - res.data.refunded;
            this.orderTime = timeToDate(res.data.ctime);
          } else {
            this.$msg("订单不可以进行售后", "error");
          }
        } else {
          this.$msg("没有找到此订单", "error");
        }
      });
    }
  },
  created() {},
  mounted() {
    let order_id = this.$route.params.order_id;
    this.order_id = order_id;
    this.getOrderInfo();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.result {
  margin-bottom: 20px;
}
.order-box {
  display: flex;
  text-align: center;
  align-items: center;
  &.list-head {
    height: 40px;
    line-height: 40px;
    background: $theme-bg;
  }
  &.list-box {
    border: 1px solid $border;
    border-top: none;
    .order-list {
      display: inline-flex;
      border-left: 1px solid $border;
      border-right: 1px solid $border;
      padding: 20px 0;
      .product-item {
        margin: 0 10px;
        .product-img {
          display: block;
          width: 50px;
          height: 50px;
          object-fit: contain;
          margin-bottom: 10px;
        }
        .apply-btn {
          width: 50px;
          height: 20px;
          line-height: 20px;
          border: 1px solid $border;
          cursor: pointer;
          color: $theme-color;
          font-size: 12px;
          &.active {
            background: $theme-color;
            color: #fff;
          }
          &:hover {
            background: $theme-color;
            color: #fff;
          }
        }
      }
    }
  }
  .order-id {
    width: 200px;
  }
  .order-list {
    flex: 1;
  }
  .order-time {
    width: 200px;
  }
}
.a-box {
  display: flex;
  margin-bottom: 10px;
  padding: 8px 0;
  .a-label {
    display: inline-block;
    width: 80px;
    text-align: right;
    margin-right: 20px;
    &.top10 {
      margin-top: 10px;
    }
  }
  .a-main {
    display: inline-flex;
    .a-img {
      width: 75px;
      height: 75px;
      display: inline-block;
      object-fit: cover;
      margin-right: 20px;
    }
    .a-name {
      display: inline-block;
    }
    .a-price-input {
      display: block;
      width: 180px;
      height: 30px;
      text-indent: 10px;
      color: $theme-color;
      font-size: 16px;
      border: 1px solid $border;
    }
    .textarea {
      width: 480px;
      resize: none;
      border: 1px solid $border;
      padding: 10px;
      &:focus {
        outline: none;
        border-color: $theme-color;
      }
    }
  }
}
.submit {
  width: 200px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: $theme-color;
  color: #fff;
  margin-left: 100px;
  margin-top: 30px;
  cursor: pointer;
}
</style>